import { Controller } from "@hotwired/stimulus"

// Generic "changing this input submits the form" pattern -- screener uses
// it for the order/payment radio choice, clicking the button target
// (rather than calling this.element.requestSubmit()) since the target
// button's own name/value ("orders") is what the server reads to tell an
// orders-report submit apart from a csv-download submit on the same form.
export default class extends Controller {
  static targets = ["button"]

  submit() {
    this.buttonTarget.click()
  }
}
